<template>
  <DatePicker
    v-model="modelValue"
    :label="$tt('expected_entry_date')"
    :max="getYearsAheadIso(1)"
    :hint="hint"
    future
  />
</template>

<script setup lang="ts">
import { getYearsAheadIso } from '../../helpers/date';
import type { DateISO } from '~/types';

const modelValue = defineModel<DateISO>({ required: true });
defineProps<{
  hint?: string;
}>();
</script>